<div *ngFor="let item of data; let i = index" class="expandable-panel">
  <!-- If children exist, display the expansion panel -->
  <ng-container *ngIf="item.children?.length > 0; else noExpansionPanel">
    <mat-expansion-panel>
      <mat-expansion-panel-header [ngClass]="getHeaderClass(item.name)">
        <mat-panel-title class="title">
          {{ item.name || item.component || "Unnamed Section" }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-expansion-panel-view [data]="item.children"></app-expansion-panel-view>
    </mat-expansion-panel>
  </ng-container>

  <!-- If no children exist, display the content directly -->
  <ng-template #noExpansionPanel>
    <div class="key-value-pairs">
      <div *ngFor="let key of objectKeys(item)">
        <ng-container *ngIf="getMeta(key) as metaInfo">
          <div class="row mb-3">
            <div class="col-3 d-flex justify-content-start text-display">
              {{ metaInfo.display_name }}
            </div>
            <div class="col-1">:</div>
            <ng-container *ngIf="metaInfo.type === 'string'">
              <span
                class="col-8 d-flex justify-content-start text-value text-start"
                >{{ item[key] }}</span
              >
            </ng-container>
            <ng-container *ngIf="metaInfo.type === 'list'">
              <app-common-list
                [items]="item[key]"
                [isOrderedList]="false"
                class="col-7 d-flex justify-content-start text-value text-start"
              >
              </app-common-list>
            </ng-container>
            <ng-container *ngIf="metaInfo.type === 'table'">
              <app-application-hospot-table class="col-7" [data]="item[key]"></app-application-hospot-table>
            </ng-container>
          </div>
        </ng-container>
      </div>
      <ng-container *ngIf="!item?.children && data?.length !== i+1">
        <hr>
      </ng-container>
    </div>
  </ng-template>
</div>
